import { render, staticRenderFns } from "./aptos-medicos-evento.vue?vue&type=template&id=6518a536&"
import script from "./aptos-medicos-evento.vue?vue&type=script&lang=js&"
export * from "./aptos-medicos-evento.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports